/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');

var react = require('react');

var useValidatedState = function useValidatedState(validator, initialValue) {
  var _useState = react.useState(initialValue),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var validation = react.useRef({
    changed: false
  });
  var onChange = react.useCallback(function (nextValue) {
    setState(nextValue);
    validation.current = {
      changed: true,
      valid: validator(nextValue)
    };
  }, [validator]);
  return [state, onChange, validation.current];
};

exports.default = useValidatedState;